import {
  HttpContextToken,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

export const DEDUP_REQUEST = new HttpContextToken<boolean>(() => false);

@Injectable()
export class RequestDedupInterceptor implements HttpInterceptor {
  private inFlight = new Map<string, Observable<HttpEvent<any>>>();

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const method = req.method.toUpperCase();

    const shouldDedup =
      method === 'POST' ||
      method === 'PUT' ||
      method === 'PATCH' ||
      method === 'DELETE' ||
      req.context.get(DEDUP_REQUEST);

    if (!shouldDedup) {
      return next.handle(req);
    }

    const key = this.buildKey(req);
    const existing = this.inFlight.get(key);
    if (existing) {
      return existing;
    }

    const subject = new ReplaySubject<HttpEvent<any>>(1);

    next.handle(req).subscribe({
      next: (event) => subject.next(event),
      error: (error) => {
        subject.error(error);
        this.inFlight.delete(key);
      },
      complete: () => {
        subject.complete();
        this.inFlight.delete(key);
      }
    });

    const shared$ = new Observable<HttpEvent<any>>((subscriber) => {
      const sub = subject.subscribe(subscriber);
      return () => {
        sub.unsubscribe();
      };
    });

    this.inFlight.set(key, shared$);
    return shared$;
  }

  private buildKey(req: HttpRequest<any>): string {
    const url = req.urlWithParams;

    let body = '';
    try {
      body = req.body == null ? '' : JSON.stringify(req.body);
    } catch {
      body = '[unserializable-body]';
    }

    const contentType = req.headers.get('content-type') ?? '';
    const accept = req.headers.get('accept') ?? '';

    return `${req.method}::${url}::ct=${contentType}::ac=${accept}::body=${body}`;
  }
}
